/**
 * Settings store — loads /api/settings/public on boot, applies the theme.
 * Admin's Settings page also calls applyTheme directly while editing so changes
 * preview live in their browser before they hit Save.
 */
import { create } from 'zustand';
import api from '../utils/api';
import { applyTheme } from '../theme/applyTheme';
import { DEFAULT_TOKENS } from '../theme/tokens';
import { DEFAULT_FINANCE } from '../utils/financeLedger';
import { DEFAULT_PAYMENT_SETTINGS } from '../utils/daewooFinance';

export const useSettings = create((set) => ({
    loaded: false,
    appName: 'AGEON CRM',
    tagline: 'Longevity & Recovery',
    theme: DEFAULT_TOKENS,
    features: {},
    finance: { ...DEFAULT_FINANCE },
    paymentSettings: { ...DEFAULT_PAYMENT_SETTINGS },
    legal: { loiStages: [], agreementStages: [] },
    kpi: { leadDayStartHour: 18 },

    async load() {
        try {
            const { data } = await api.get('/settings/public');
            const theme = data.theme || {};
            applyTheme({
                brand: {
                    teal: theme.teal, teal_700: theme.teal_700, teal_50: theme.teal_50,
                    yellow: theme.yellow, red: theme.red, dark: theme.dark,
                    orange: theme.orange, gold: theme.gold, ivory: theme.ivory,
                },
                density: theme.density,
                radius:  theme.radius,
            });
            const f = data.finance || {};
            const ps = data.paymentSettings || {};
            set({
                loaded: true,
                appName: data.appName,
                tagline: data.tagline,
                theme,
                features: data.features || {},
                finance: {
                    defaultGstPercent: Number.isFinite(Number(f.defaultGstPercent)) ? Number(f.defaultGstPercent) : DEFAULT_FINANCE.defaultGstPercent,
                    defaultTdsPercent: Number.isFinite(Number(f.defaultTdsPercent)) ? Number(f.defaultTdsPercent) : DEFAULT_FINANCE.defaultTdsPercent,
                    gstTdsRounding: f.gstTdsRounding === 'truncate2dp' ? 'truncate2dp' : 'round',
                },
                paymentSettings: { ...DEFAULT_PAYMENT_SETTINGS, ...ps },
                legal: data.legal || { loiStages: [], agreementStages: [] },
                kpi: { leadDayStartHour: Number.isFinite(Number(data.kpi?.leadDayStartHour)) ? Number(data.kpi.leadDayStartHour) : 18 },
            });
        } catch {
            set({ loaded: true });
        }
    },
}));
